import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import {
  Feature,
  FeatureNames,
  FeaturePropertyKey,
  OperatingProgramProperties,
  ProgramCommands,
} from '@vi-iot/client';

import { InstallationFeaturesStore } from '@store';

import { ScheduleService } from '../../../../../../../../features/timemanager/services';
import { HeatingPanelService } from '../../heating-panel.service';

@Component({
  selector: 'app-mfh-temperature-panel',
  templateUrl: './mfh-temperature-panel.component.html',
  styleUrls: ['./mfh-temperature-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MfhTemperaturePanelComponent implements OnInit, OnDestroy {
  readonly featurePropertyKey = FeaturePropertyKey;
  @Input() circuitId: string;
  @Input() mode: string;

  ngUnsubscribe: Subject<void> = new Subject<void>();
  feature$: Observable<Feature<OperatingProgramProperties, ProgramCommands>>;
  isActiveMode: boolean;
  isEnabled = false;

  constructor(
    public heatingPanelService: HeatingPanelService,
    private scheduleService: ScheduleService,
    private installationFeaturesStore: InstallationFeaturesStore
  ) {}

  ngOnInit(): void {
    this.subscribeToSetActiveMode();

    this.feature$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.circuitOperatingProgram(this.circuitId, this.mode)
    );
  }

  private subscribeToSetActiveMode(): void {
    this.scheduleService.programs$.pipe(takeUntil(this.ngUnsubscribe)).subscribe((programs) => {
      this.isActiveMode = !!programs.find((mode) => mode.name === this.mode);
      this.isEnabled = true;
    });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
